import React, { useState, useEffect } from "react";
import { Container, Card, Form, Spinner } from "react-bootstrap";
import NavHeader from "components/Navbar";
import Airtable from "airtable";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { ArrowLeft } from "lucide-react";
import ProgressBar from "components/ProgressBar";
import emailjs from "@emailjs/browser";
import Spinners from "components/Spinners";
import EmailSection from "questions/EmailSection";
import BasicQuestion from "questions/BasicQuestion";
import DomainQuestion from "questions/DomainQuestion";
import Questions from "questions/Questions";
import FirstSection from "questions/FirstSection";
import SecondSection from "questions/SecondSection";
import Info from "./Info";
// Airtable configuration
const base = new Airtable({
  apiKey: process.env.REACT_APP_ACCESS_TOKEN,
}).base(process.env.REACT_APP_BASE_ID);

export default function Assessment() {
  const [formState, setFormState] = useState({
    answers: {},
    userId: "",
    comments: {},
    email: "",
    feedback: "",
    selectedDomain: "",
    domainData: [],
    sectionData: [],
    formSubmitted: false,
    questionsData: [],
    currentStep: "nonDomainQuestions",
    loading: true,
    score: 0,
    filteredQuestions: {
      nonDomainQuestions: [],
      filteredQuestions: [],
      filteredSectionQuestions: [],
      filteredSecondSectionQuestions: [],
    },
  });
  // const [weightCount,setWeightCount]=useState(0);
  const [step, setStep] = useState(0);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState("");
  const [errors, setErrors] = useState({});
  const [weightError, setWeightError] = useState({});
  const [show, setShow] = useState(false);
  const [count, setCount] = useState(0);
  const [qlen, setQlen] = useState({
    nonDomain: 0,
    filtered: 0,
    filteredSec: 0,
    filtersecondsec: 0,
  });



  useEffect(() => {
    check();
  }, [weightError]);
  function check() {
    
    const currentDomainStep = formState.currentStep;
    
    
    const currentDomainQuestions = formState.filteredQuestions?.[currentDomainStep] || [];
    const validAnswersCount = currentDomainQuestions.filter(
      (q) => weightError[q.id] === true
    ).length;
  
    const weightErrorsInCurrentDomain = validAnswersCount === count;
    if (weightErrorsInCurrentDomain) {
      setShow(false);
    }
  }

  

  const nextButton = (e, nextstep, count) => {
    e.preventDefault();
  
    const currentDomainStep = formState.currentStep;
    
    
    const currentDomainQuestions = formState.filteredQuestions?.[currentDomainStep] || [];
  
    const validAnswersCount = currentDomainQuestions.filter(
      (q) => weightError[q.id] === true
    ).length;
  
    const weightErrorsInCurrentDomain = validAnswersCount === count;
    let commentErrorFound = false;
    const newErrors = { ...errors };
  
    currentDomainQuestions.forEach((question) => {
      const questionId = question.id;
      const selectedAnswer = formState.answers?.[questionId]?.[0];
      const comment = formState.comments?.[questionId]?.trim();
  
      if (selectedAnswer === "other") {
        if (!comment) {
          commentErrorFound = true;
          newErrors[`${questionId}_comment`] = "Please provide a comment for 'Other'.";
        } else {
          delete newErrors[`${questionId}_comment`];
        }
      }
    });
  
    setErrors(newErrors);
    setCount(count);
    if (weightErrorsInCurrentDomain && !commentErrorFound) {
      setShow(false);
      setFormState((prev) => ({
        ...prev,
        currentStep: nextstep,
      }));
      setStep((prev) => prev + 1);
    } else {
      setShow(true);
    }
  };
  
  
  const nextdomain = (e, nextstep) => {
    e.preventDefault();
    if (formState.selectedDomain === "") {
      setShowError("please choose a domain");
    } else if (formState.selectedDomain === "recmWTRMPGoTVLpup") {
      setShowError("currently we don't have any questions for this domain");
    } else {
      setFormState((prev) => ({ ...prev, currentStep: nextstep }));
      setStep((prev) => prev + 1);
      setShowError("");
    }
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };
  const handleEmailChange = (e) => {
    if (!isValidEmail(e.target.value)) {
      setError("Invalid email address!");
    } else {
      setError("");
    }
    setFormState((prevState) => ({
      ...prevState,
      email: e.target.value,
    }));
  };
  const handleFeedbackChange = (e) => {
    setFormState((prevState) => ({
      ...prevState,
      feedback: e.target.value,
    }));
  };

  const handleDomainChange = (e) => {
    // console.log(e.target.value);

    setFormState((prevState) => ({
      ...prevState,
      selectedDomain: e.target.value,
    }));
  };

  const handleAnswerChange = (
    isWeight,
    questionId,
    value,
    isChecked,
    isCustom = false,
    domain
  ) => {
    setFormState((prevState) => {
      let updatedAnswers = prevState.answers[questionId] || [];

      if (isCustom) {
        console.log(isCustom);
        
        updatedAnswers = value ? [value] : [];
      } else {
        if (isChecked) {
          updatedAnswers = [value];
        } else {
          updatedAnswers = updatedAnswers.filter((ans) => ans !== value);
        }
      }

      if (updatedAnswers.includes("other")) {
        setErrors((prev) => ({
          ...prev,
          [`${questionId}_comment`]: prevState.comments?.[questionId]
            ? null
            : "Please provide a comment for 'Other'.",
        }));
      } else {
        setErrors((prev) => {
          const updated = { ...prev };
          delete updated[`${questionId}_comment`];
          return updated;
        });
      }

      if (isWeight) {
        const hasAnySelected = updatedAnswers.length > 0;
        // setWeightError((prev) => {
        //   const updatedWeightError = { ...prev };
        //   if (domain) {
        //     updatedWeightError[domain] = hasAnySelected;
        //   }
        //   return updatedWeightError;
        // });
        setWeightError((prev) => ({
          ...prev,
          [questionId]: hasAnySelected,
        }));
      }

      return {
        ...prevState,
        answers: {
          ...prevState.answers,
          [questionId]: updatedAnswers,
        },
      };
    });
  };

  const handleAnswerChangeSecond = (
    isWeight,
    questionId,
    value,
    isChecked,
    isCustom = false,
    domain
  ) => {
    const regex = /^[A-Za-z\s]*$/;

    if (!regex.test(value)) {
      setErrors((prev) => ({
        ...prev,
        [questionId]: "Only alphabets allowed!",
      }));
    } else {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[questionId];
        return newErrors;
      });
    }
    setFormState((prevState) => {
      let updatedAnswers = prevState.answers[questionId] || [];

      if (isCustom) {
        updatedAnswers = value ? [value] : [];
      } else {
        if (isChecked) {
          updatedAnswers = [...updatedAnswers, value];
        } else {
          updatedAnswers = updatedAnswers.filter((ans) => ans !== value);
          if (value === "other") {
            return {
              ...prevState,
              answers: {
                ...prevState.answers,
                [questionId]: updatedAnswers,
              },
              comments: {
                ...prevState.comments,
                [questionId]: "",
              },
            };
          }
        }
      }


      if (updatedAnswers.includes("other")) {
        setErrors((prev) => ({
          ...prev,
          [`${questionId}_comment`]: prevState.comments?.[questionId]
            ? null
            : "Please provide a comment for 'Other'.",
        }));
      } else {
        setErrors((prev) => {
          const updated = { ...prev };
          delete updated[`${questionId}_comment`];
          return updated;
        });
      }

      // if (isWeight) {
      //   const hasAnySelected = updatedAnswers.length > 0;
      //   setWeightError((prev) => {
      //     const updatedWeightError = { ...prev };
      //     if (domain) {
      //       updatedWeightError[domain] = hasAnySelected;
      //     }
      //     return updatedWeightError;
      //   });
      // }
      if (isWeight) {
        const hasAnySelected = updatedAnswers.length > 0;
        setWeightError((prev) => ({
          ...prev,
          [questionId]: hasAnySelected,
        }));
      }

      return {
        ...prevState,
        answers: {
          ...prevState.answers,
          [questionId]: updatedAnswers,
        },
      };
    });
  };

  const handleCommentChange = (questionId, value) => {
    setFormState((prevState) => {
      const updatedState = {
        ...prevState,
        comments: {
          ...prevState.comments,
          [questionId]: value,
        },
      };
  
      // Check if "other" is selected for that question
      const isOtherSelected =
        prevState.answers?.[questionId]?.[0] === "other";
  
      // Set or clear comment error
      setErrors((prevErrors) => ({
        ...prevErrors,
        [`${questionId}_comment`]: isOtherSelected && !value.trim()
          ? "Please provide a comment for 'Other'."
          : null,
      }));
  
      return updatedState;
    });
  };
  

  // Fetch questions
  const fetchQuestion = async () => {
    try {
      const res = await base("InteractiveQuestion")
        .select({ view: "Grid view" })
        .all();
      setFormState((prevState) => ({
        ...prevState,
        questionsData: res,
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching questions:", error);
      setFormState((prevState) => ({ ...prevState, loading: false }));
    }
  };

  // Fetch domains
  const fetchDomain = async () => {
    try {
      const res = await base("Domain").select({ view: "Grid view" }).all();
      setFormState((prevState) => ({
        ...prevState,
        domainData: res,
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching domains:", error);
      setFormState((prevState) => ({ ...prevState, loading: false }));
    }
  };
  // const [score,setScore]=useState(0);
  const calculateTotalScore = () => {
    let totalScore = 0;
    const { answers, questionsData, score } = formState;

    questionsData.forEach((question) => {
      if (answers && answers[question.id] && answers[question.id].length > 0) {
        if (question.fields.weight) {
          totalScore += question.fields.weight;
        }
      }
    });

    // Only update state if the score changes
    if (totalScore !== score) {
      setFormState((prev) => ({ ...prev, score: totalScore }));
    }
    return totalScore;
  };

  useEffect(() => {
    calculateTotalScore();
    fetchDomain();
    fetchQuestion();
  }, []);

  useEffect(() => {
    const { selectedDomain, questionsData } = formState;

    if (!questionsData || !questionsData.length) return;

    // Filter questions with no domain_id and no section_id
    const noDomainSectioQuestions = questionsData.filter(
      (q) => !q.fields.domain_id && !q.fields.section_id
    );
    const countGreaterThanZero = noDomainSectioQuestions.filter(
      (obj) => obj.fields.weight > 0
    ).length;
    setQlen((prev) => ({
      ...prev,
      nonDomain: countGreaterThanZero,
    }));

    // Filter questions that match the selected domain
    const domainQuestions = questionsData.filter(
      (q) => q.fields.domain_id && q.fields.domain_id.includes(selectedDomain)
    );
    const countGreaterThanZerosecond = domainQuestions.filter(
      (obj) => obj.fields.weight > 0
    ).length;
    setQlen((prev) => ({
      ...prev,
      filtered: countGreaterThanZerosecond,
    }));

    const firstSectionQuestions = [];
    const secondSectionQuestions = [];

    questionsData.forEach((q) => {
      if (q.fields.section_id === 1) {
        firstSectionQuestions.push(q);

        const countGreaterThanZero = firstSectionQuestions.filter(
          (obj) => obj.fields.weight > 0
        ).length;
        setQlen((prev) => ({
          ...prev,
          filteredSec: countGreaterThanZero,
        }));
      } else if (q.fields.section_id === 2) {
        secondSectionQuestions.push(q);
        const countGreaterThanZero = secondSectionQuestions.filter(
          (obj) => obj.fields.weight > 0
        ).length;
        setQlen((prev) => ({
          ...prev,
          filtersecondsec: countGreaterThanZero,
        }));
      }
    });

    // Update the state correctly
    setFormState((prevState) => ({
      ...prevState,
      filteredQuestions: {
        nonDomainQuestions: noDomainSectioQuestions,
        filteredQuestions: domainQuestions,
        filteredSectionQuestions: firstSectionQuestions,
        filteredSecondSectionQuestions: secondSectionQuestions,
      },
    }));
  }, [formState.selectedDomain, formState.questionsData]);

  const chunkArray = (array, chunkSize) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  };

  const sendScoreToEmail = async (email, score, score_date) => {
    try {
      const response = await emailjs.send(
        process.env.REACT_APP_SERVICE_ID || "service_q6uk6ie", // Replace with EmailJS Service ID
        process.env.REACT_APP_TEMPLATE_ID || "template_leytgvw",
        {
          user_email: email,
          user_score: score,
          score_date: score_date,
        },
        process.env.REACT_APP_PUBLIC_ID || "ud4wyrEdd5wMSkHvF" // ✅ Replace with your EmailJS Public Key
      );
    } catch (error) {
      console.error("Error sending email:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formState.currentStep === "email") {
      setLoading(true);
      try {
        setStep(step + 1);
        const { email, answers, comments, feedback } = formState;

        // Check if user already exists
        const existingUser = await base("User")
          .select({
            filterByFormula: `{email} = '${email}'`,
          })
          .firstPage();

        let userRecord;
        if (existingUser.length === 0) {
          userRecord = await base("User").create([
            { fields: { email: email } },
          ]);
          setFormState((prev) => ({ ...prev, userId: userRecord[0].id }));
          userRecord = userRecord[0];
        } else {
          userRecord = existingUser[0];
          setFormState((prev) => ({ ...prev, userId: userRecord.id }));
        }

        // Collect answers
        const allAnswers = [];
        const { filteredQuestions } = formState;

        const questionGroups = [
          filteredQuestions.nonDomainQuestions,
          filteredQuestions.filteredQuestions,
          filteredQuestions.filteredSectionQuestions,
          filteredQuestions.filteredSecondSectionQuestions,
        ];

        questionGroups.forEach((group) => {
          group.forEach((question) => {
            if (answers[question.id]) {
              allAnswers.push({
                fields: {
                  question_id: [question.id],
                  answer: Array.isArray(answers[question.id])
                    ? answers[question.id].join(", ")
                    : answers[question.id],
                  comments: comments[question.id] || "",
                  user_id: [userRecord.id],
                },
              });
            }
          });
        });

        if (feedback !== "") {
          allAnswers.push({
            fields: {
              question_id: [],
              answer: "Feedback from User",
              comments: feedback,
              user_id: [userRecord.id],
            },
          });
        }

        // Split answers into batches of 10
        const answerBatches = chunkArray(allAnswers, 10);

        // Submit each batch sequentially
        for (const batch of answerBatches) {
          await base("InteractiveAnswer").create(batch);
        }
        const totalScore = calculateTotalScore();
        var score_date = new Date().toLocaleDateString();

        setFormState((prev) => ({
          ...prev,
          score: totalScore,
          formSubmitted: true,
        }));

        await sendScoreToEmail(email, totalScore, score_date);
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setSuccess(false);
        setLoading(false);
      }
    }
  };

  const sharedFormProps = {
    handleSubmit,
    formState,
    show,
    weightError,
    handleAnswerChangeSecond,
    handleAnswerChange,
    errors,
    handleCommentChange,
    setFormState,
    setStep,
    step,
    nextButton,
    qlen,
  };
  const renderFormStep = () => {
    switch (formState.currentStep) {
      case "email":
        return (
          <EmailSection
            handleSubmit={handleSubmit}
            handleEmailChange={handleEmailChange}
            handleFeedbackChange={handleFeedbackChange}
            formState={formState}
            setFormState={setFormState}
            error={error}
            setStep={setStep}
            step={step}
            loading={loading}
          />
        );

      case "nonDomainQuestions":
        if (formState.loading)
          return <Spinner animation="border" variant="primary" />;
        return <BasicQuestion {...sharedFormProps} />;

      case "domain":
        if (formState.loading)
          return <Spinner animation="border" variant="primary" />;
        return (
          <DomainQuestion
            formState={formState}
            handleDomainChange={handleDomainChange}
            showError={showError}
            setFormState={setFormState}
            setStep={setStep}
            step={step}
            nextdomain={nextdomain}
          />
        );

      case "filteredQuestions":
        if (formState.loading)
          return <Spinner animation="border" variant="primary" />;
        return <Questions {...sharedFormProps} />;

      case "filteredSectionQuestions":
        if (formState.loading)
          return <Spinner animation="border" variant="primary" />;
        return <FirstSection {...sharedFormProps} />;

      case "filteredSecondSectionQuestions":
        if (formState.loading)
          return <Spinner animation="border" variant="primary" />;
        return <SecondSection {...sharedFormProps} />;

      default:
        return null;
    }
  };
  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.3 },
  };
  return (
    <motion.section {...fadeIn}>
      <div className="min-vh-100">
        <div style={{ position: "sticky", top: "0", zIndex: "100" }}>
          <NavHeader />
        </div>
        <Container className=" py-5">
          <div className="row  g-4">
            <div className="col-lg-6 media-width-forth">
              <Info />
            </div>
            <div className=" col-lg-6 media-width-second">
              {!formState.formSubmitted ? (
                <Card
                  className="custom-card no-hover-card"
                  style={{ backgroundColor: "#fafafa" }}
                >
                  <Card.Header className=" new-bgc px-3 py-2">
                    <Card.Title className="head-font fw-normal fs-3 fw-bolder">
                      Start your Assessment
                    </Card.Title>
                    <p>
                      Complete the form below to evaluate your AI system's
                      compliance
                    </p>
                    <div>
                      <ProgressBar totalSteps={6} currentStep={step} />
                    </div>
                  </Card.Header>
                  <Card.Body>{renderFormStep()}</Card.Body>
                </Card>
              ) : (
                <div className="text-center">
                  {/* <h3 className="mt-5">Thank you for your feedback!</h3> */}
                  {formState.formSubmitted && (
                    <div>Your response has been saved successfully</div>
                  )}
                  <button
                    className="w-100 py-2 rounded mt-4 border-0 text-white bg-progress"
                    onClick={() => (window.location.href = "/")} // Redirects to home
                  >
                    Back to Home
                  </button>
                </div>
              )}
            </div>
          </div>
        </Container>
      </div>
    </motion.section>
  );
}
